import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { alpha } from '@mui/material/styles';
import type React from 'react';

interface DialogHeaderProps {
  header?: string;
  onClose?: (() => void) | null;
}

/**
 * DialogHeader — matches .modal-header from mockup exactly.
 *
 * Replaces MUI DialogTitle to avoid its opinionated padding/typography.
 * Padding: 16px 24px. Title: 18px/500. Close: 36x36 circle.
 */
const DialogHeader: React.FC<DialogHeaderProps> = ({ header = '', onClose = null }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      px: 3, // 24px
      py: 2, // 16px
    }}
  >
    <Box
      component="span"
      sx={{
        flex: 1,
        fontSize: '18px',
        fontWeight: 500,
        color: (theme) => theme.palette.text.primary,
      }}
    >
      {header}
    </Box>
    {onClose && (
      <IconButton
        onClick={onClose}
        size="small"
        sx={{
          width: 36,
          height: 36,
          color: (theme) => theme.palette.text.secondary,
          '&:hover': {
            bgcolor: (theme) => alpha(theme.palette.common.white, 0.08),
          },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    )}
  </Box>
);

export default DialogHeader;
